<template>
  <svg @click="trigger" :style="{fontSize:size+'px'}" class="svgicon" aria-hidden="true">
    <use :xlink:href="iconName"></use>
  </svg>
  <!-- <div>13123</div> -->
</template>

<script>
export default {
    props:{
        name : String,
        size:{
            type:String,
            default:'20'
        }
    },
    computed:{
        iconName(){
            return '#icon-'+this.name
        }
    },
    methods:{
        trigger(e){
            this.$emit('click',e)
        }
    }
};
</script>

<style>
.svgicon {
   width: 1em; height: 1em;
   vertical-align: -0.15em;
   fill: currentColor;
   overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/public/SvgIcon.vue